module.exports = __webpack_public_path__ + "img/sliders-03.619a6f8f.jpg";